export const formRules = {
  name: [{ required: true, message: "请输入结算单位名称" }],
};
